"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphContainerSchema = void 0;
exports.ParagraphContainerSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/paragraph-container.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ParagraphContainer",
    "description": "A paragraph container holds multiple paragraphs. This can be used to store content for a story body",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:paragraph-container"
            ]
        },
        "contents": {
            "type": "array",
            "items": {
                "$ref": "https://www.redbull.com/schemas/attributes/paragraph.schema.json"
            }
        }
    },
    "required": [
        "type",
        "contents"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFyYWdyYXBoLWNvbnRhaW5lci5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9hdHRyaWJ1dGVzL3BhcmFncmFwaC1jb250YWluZXIuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsd0JBQXdCLEdBQUc7SUFDdEMsS0FBSyxFQUFFLDRFQUE0RTtJQUNuRixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxvQkFBb0I7SUFDN0IsYUFBYSxFQUFFLHFHQUFxRztJQUNwSCxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTixnQ0FBZ0M7YUFDakM7U0FDRjtRQUNELFVBQVUsRUFBRTtZQUNWLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSxrRUFBa0U7YUFDM0U7U0FDRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLFVBQVU7S0FDWDtDQUNGLENBQUEifQ==